import React, { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import SessionStorageCache from 'core/utils/cache/sessionStorage';
import BottomSticky from 'core/modules/BottomSticky/BottomSticky';
import { getHasPreviouslyLoggedIn } from 'core/utils/helpers/hasPreviouslyLoggedIn';
import WistiaVideo from 'core/modules/WistiaVideo/WistiaVideo';
import Welcome from './components/Welcome/Welcome';
import Benefits from './components/Benefits/Benefits';
import HowItWorks from './components/HowItWorks/HowItWorks';
import DisclaimerText from './components/DisclaimerText/DisclaimerText';
import LargeNagSignIn from './components/LargeNagSignIn/LargeNagSignIn';

import './SignInNagLarge.scss';

const sessionStorageCache = new SessionStorageCache();
const videoId = 'wce43ceygw';

function SignInNagLarge({ handleClose, scrollToTerms }) {
  const [showVideo, setShowVideo] = useState(false);
  const [isReturnedAnonimousUser, setIsReturnedAnonimousUser] = useState(false);
  const disclaimerTextRef = useRef();

  const onHideVideo = () => setShowVideo(false);
  const onShowVideo = () => setShowVideo(true);

  const renderVideoContent = () =>
    <WistiaVideo videoId={videoId} handleClose={onHideVideo} />;

  const renderNagContent = () => (
    <div className="mn_innerWrap">
      <button className="mn_closeSignInNagX" aria-label="Close dialog" onClick={handleClose} />
      <div className="mn_contentSection mn_nagLargeContent">
        <Welcome handleVideoClick={onShowVideo} isReturnedAnonimousUser={isReturnedAnonimousUser} />
        <HowItWorks />
        <Benefits />
        { !isReturnedAnonimousUser &&
          <DisclaimerText setRef={(disclaimerText) => { disclaimerTextRef.current = disclaimerText; }} />
        }
      </div>
      { !isReturnedAnonimousUser &&
        <CSSTransition
          in
          appear
          timeout={2000}
          classNames="mn_slideup"
        >
          <BottomSticky>
            <LargeNagSignIn handleClose={handleClose} />
          </BottomSticky>
        </CSSTransition>
      }
    </div>
  );

  useEffect(() => {
    sessionStorageCache.setItem('sawSignInNagLarge', '1');
    const hasPreviouslyLoggedIn = getHasPreviouslyLoggedIn();

    if (hasPreviouslyLoggedIn) {
      setIsReturnedAnonimousUser(true);
    }

    if (scrollToTerms) {
      const fullScreenDOMNode = document.getElementsByClassName('mn_fullScreen')[0];
      if (fullScreenDOMNode) {
        fullScreenDOMNode.scrollTop = disclaimerTextRef.current.offsetTop;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mn_signInNagLarge">
      {showVideo ? renderVideoContent() : renderNagContent()}
    </div>
  );
}

export default SignInNagLarge;
